import React, { useState, useEffect,useRef } from 'react';
import axios from 'axios';
import { useHistory } from "react-router-dom";

import MaterialTable from "material-table";
import Sidebar from '../../Template/Sidebar/Sidebar';
import Header from '../../Template/Header/Header';
import {baseUrl} from '../../../config';
import DatePicker from "react-datepicker";
import moment from 'moment'
import CloseIcon from '@mui/icons-material/Close';
import "react-datepicker/dist/react-datepicker.css";
import {formatNumberWithToFixed} from '../ProfitabilityDiagnosis/js/commanFn';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import Loader from 'react-loader-spinner';
import {clickColor,inArray} from './../../../library/util';
import { yellow } from '@mui/material/colors';
import {getMonday} from './common';

import AddIcon from '@mui/icons-material/Add';
import AsyncSelect from 'react-select/async';
import makeAnimated from 'react-select/animated';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import axiosIntance from '../../../helper/axios';

import { checkAccess, FEATURES } from '../../../library/auth'

const animatedComponents = makeAnimated();

const colourStyles = {
  menuList: styles => ({
      ...styles,
      background: 'white'
  }),
  option: (styles, {isFocused, isSelected}) => ({
      ...styles,
      background: isFocused
          ? 'lightblue'
          : isSelected
              ? '#2a7bc0'
              : undefined,
      zIndex: 1
  }),
  menu: base => ({
      ...base,
      zIndex: 100
  })
  }
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };



  const AddIconClasses={ color: '#337ab7',fontSize:'30px',marginLeft:'128px',marginTop:"-15px",cursor: 'pointer' };


function Shipcostbypickupdate() {
    const history = useHistory();
    const [selectedRow, setSelectedRow] = useState(null);
    const ReportTile='Ship Cost by Pickup Date ';
    const [startDate, setStartDate] = useState(getMonday(new Date()));
    const [endDate, setEndDate] = useState(new Date(Date.now() - 864e5))
    const [AFFID,setAFFID]=useState('');
    const [AFFIDArray,setAFFIDArray]=useState([]);
    const [selectedrowList,setSelectedRowList]=useState([]);

    /******************* Advanced Filter Work *************/


    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [open, setOpen] = React.useState(false);
    const [filterLabel,setFilterLabel]=useState([])
    const [filterValue,setFilterValue]=useState('')
    const [filterArray,setFilterArray]=useState([]);
    const selectInputRef = useRef();
    const selectInputRefInputFilter=useRef();
    const [group,setgroup]=useState('');
    const [groupArray,setgroupArray]=useState([]);

    const typeTable='firstmile';

    const [selectLabelHeader,setSelectLabelHeader]=useState([
      {label:"invoice_date",value:"invoice_date",group:"invoice_date"},
      {label:"invoice_number",value:"invoice_number",group:"invoice_number"},
      {label:"pickup_date",value:"pickup_date",group:"pickup_date"},
      {label:"tracking_number",value:"tracking_number",group:"tracking_number"},
      {label:"total_charge",value:"total_charge",group:"total_charge"},
      {label:"product_1",value:"product_1",group:"product_1"},
      {label:"product_2",value:"product_2",group:"product_2"},
      {label:"label_number",value:"label_number",group:"label_number"},
      {label:"fm_base_rate",value:"fm_base_rate",group:"fm_base_rate"},
      {label:"zone",value:"zone",group:"zone"},
      {label:"weight_oz",value:"weight_oz",group:"weight_oz"},
      {label:"weight_lbs",value:"weight_lbs",group:"weight_lbs"},
      {label:"billing_ref",value:"billing_ref",group:"billing_ref"},
      {label:"billing_ref2",value:"billing_ref2",group:"billing_ref2"},
      {label:"recipient_name",value:"recipient_name",group:"recipient_name"},
      {label:"recipient_address",value:"recipient_address",group:"recipient_address"},
      {label:"recipient_address2",value:"recipient_address2",group:"recipient_address2"},
      {label:"recipient_city",value:"recipient_city",group:"recipient_city"},
      {label:"recipient_state",value:"recipient_state",group:"recipient_state"},

      {label:"recipient_country",value:"recipient_country",group:"recipient_country"},
      {label:"recipient_zip",value:"recipient_zip",group:"recipient_zip"},
      {label:"fuel",value:"fuel",group:"fuel"},


    ]);


    const setRowBackground = (selectedRow)=>{
      if(inArray(selectedRow.tableData.id,selectedrowList)==false){ 
      setSelectedRowList(oldArray => [...oldArray,selectedRow.tableData.id] );
      setSelectedRow(selectedRow.tableData.id)
      console.log(selectedrowList)
      }else{    
        setSelectedRow(500000)
        setSelectedRowList([])
      }
    }
    const handleChange=( target )=> {
      if(target!=undefined){
        setgroup(target.value);
      }
  }
  const deleteAdvancedFilterFn = (item,index) =>{
    console.log(filterArray[index])
   const arr = filterArray.filter((item,j) => j!=index);
   console.log(arr)
   setFilterArray(arr);
  }
  
  const handleChangeFilter=(e)=>{
    if(e.target.value!=undefined){
      setFilterValue(e.target.value);
    }
  }
  
  const addFilter=()=>{
    console.log('addFilter',group,filterValue)
    if(group!='' && filterValue!=''){
      let tempObj={field:group,value:filterValue};  
        filterArray.push(tempObj);
        setFilterArray(filterArray);
        setFilterValue('')
    }
  }
   
    const handleSignOut = () => {
        window.localStorage.setItem('isLogin',false);
        history.push('/');
      }
      const loadFilterLabel=(inputValue)=>
  {
    let tempCategory=selectLabelHeader;
    return new Promise((resolve) => {
      resolve(tempCategory.filter((i) =>
            i.label.toLowerCase().includes(inputValue.toLowerCase())
       ))
    });
   // loanGroupCategoryFnChild('1');
  }
     
   
    if(localStorage.getItem('isLogin')==="false" || localStorage.getItem('isLogin')==null){
      history.push('/');
    }

    checkUserTypeFn(history);

    function checkUserTypeFn(history){
      const userdata=JSON.parse(localStorage.getItem('userdata'));
      const usertype=userdata.type;
      console.log('in check usertype fn');
      console.log(usertype)
      if (!checkAccess(FEATURES.ship_cost_by_pickup_date)) {
        history.push('/');
      }
    }
  
    const [reportData,setReportData]=useState([])
    const [loader,setLoader]=useState(false)
    
    const [message, setMessage] = useState('')
    const data = [['attribute', 'attribute2'], ['value1', 'value2']];
    const [successMsg,setSuccessMsg]=useState('')
    useEffect(() => {
      //fetchApi();
      return () => {
        console.log('un subscribe')
      }
  
  
  
    }, [])
    
    const ResetFilter = () => {
      setMessage('')
      setEndDate(new Date(Date.now()))
      
      setStartDate(getMonday(new Date()));
    }
   
  const fetchApi = () =>{
    console.log('here check')
    console.log(startDate)
    if(startDate==null){
      setMessage('Date must not be blank')
      return false;
    }else{
      setMessage('')
    }
    setLoader(true)
    let filterString='';

    console.log(filterArray);
    filterArray.forEach((i,j)=>{
      filterString+=`${i.field}=${i.value}*`
    })
  
    
axiosIntance.get(baseUrl+'/reports/shippingreports/shipcostbypickupdate?invoicedate='+moment(startDate).format('YYYY-MM-DD')+"&filter="+filterString, {}).then(response => {

    
        if (response.data.result.length > 0) {
          
          response.data.result.forEach((i,j)=>{
            i.total_charge="$"+formatNumberWithToFixed(i.total_charge).toLocaleString();
          });
          setReportData(response.data.result);
          
          console.log(response.data.result)
          setLoader(false)
          //setSuccessMsg('Data')
        } else {
          setLoader(false)
          setReportData([]);
          //setMessage('No data');
          console.log(45)
         // history.push('/home');
        }
  
      }).catch(error => {
        setLoader(false)
        setMessage('Something went wrong');
      });
  }

  const fetchApiDownload = () =>{
    let filterString='';
    console.log(filterArray);
    filterArray.forEach((i,j)=>{
      filterString+=`${i.field}=${i.value}*`
    })
    const token = window.localStorage.getItem('token');
      window.location.href=baseUrl+'/reports/shippingreports/shipcostbypickupdate/download?invoicedate='+moment(startDate).format('YYYY-MM-DD')+"&filter="+filterString+"&token="+token;
    
  }

  const FilterSet=() =>{
    console.log('Filter resete');
    console.log(AFFID);
    if(AFFID!=''){
        if(inArrayForString(AFFID,AFFIDArray)==false){ 
        setAFFIDArray(oldArray => [...oldArray,AFFID] );
        setAFFID('');
        }
      } 
    }
   
  

    const deleteAFFIDFn = (item,index) =>{
        console.log(item);
        removeItemOnce(AFFIDArray,item);
        console.log(AFFIDArray);
    
        let temp = AFFIDArray.filter((category) => category !== item);
        console.log(temp);
        setAFFIDArray(temp);
      }
  
  
  function removeItemOnce(arr, value) {
    var index = arr.indexOf(value);
    if (index > -1) {
      arr.splice(index, 1);
    }
    return arr;
  }
   
   
    return (
  
      <div id="wrapper" className>
        <Sidebar />
        <Header handleSignOut={handleSignOut} />



  <div></div> 
  <div></div>
  <div></div> 
  <div></div>
     
      <div className='errorMsg'>{message}</div>
      <div className='successMsg viewScreen'>{successMsg}</div>
  
  
  
    <section id="content-wrapper">

    <div classname="advancedFilterSection">
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
     <Box sx={style}>


<label>Firstmile Header</label>
<label className='filterValueStyle'>Filter Values</label> 
<div class="input-bar">

<div className="input-bar-item width100">

<AsyncSelect
ref={selectInputRef}
components={animatedComponents}
onChange={e => handleChange(e)} 
  cacheOptions
  defaultOptions
  maxMenuHeight={250} 
  className="widthSelectInput"
  classNamePrefix="select"
    styles={colourStyles}
  getOptionLabel={(e) => e.value}
  getOptionValue={(e) => e.value}
  loadOptions={loadFilterLabel}        
/>
</div>

<>

&nbsp;&nbsp;&nbsp;
<div className="input-bar-item width100">
  <input type='text'
     ref={selectInputRefInputFilter}
     className='width140x filterValue'
     placeholder="Value"
     onChange={e => handleChangeFilter(e)} 
     />
  <AddIcon style={AddIconClasses} onClick={addFilter}/>
</div>
</>

 
<div className="input-bar-item width100">
<div className="input-bar-item closeModel closeIconCommon"> 
<CloseIcon className='closeIcon' onClick={handleClose}/>
</div>
</div>

</div>

<div className="input-bar-item width100">
<div className="FilterSection">

    {filterArray.map((item, index) => (
      <>
        <span className='filterCategory' id={index}>
        <span className="filterSpan">{item.field} = {item.value}</span>
        <CloseIcon onClick={(event) => deleteAdvancedFilterFn(item,index)} className='closeIcon'/>
        </span>
        <span className="whitespaceSpan">{ '            ' }</span>
        </>
    ))}
</div>

</div>




     </Box>
     </Modal>
</div>

    <label>Date for Invoice</label>
    <div class="input-bar">
    <div className="input-bar-item width100">
    
    <DatePicker
      dateFormat="yyyy-MM-dd"
      selected={startDate}
      className='width140x'
      onChange={(date) => setStartDate(date)}
      placeholder='Date Of Invoice'
      />

    </div>
    
    &nbsp;&nbsp;&nbsp;
 
 

    &nbsp;&nbsp;&nbsp;
{/*  
    <div className="input-bar-item">
    
    <input type='text'
     name='affid'
     value={AFFID}
     className='width50x'
     placeholder="AFFID"
     onChange={e => setAFFID(e.target.value)}
     />
      
    </div> */}

    {/* <div className="input-bar-item">
    <button type="button"  onClick={FilterSet} className="btn btn-primary">Filter</button>
   
    </div> */}

<div className="input-bar-item">
    <button type="button"  onClick={handleOpen}  className="btn btn-primary">Advanced Filter</button>
   
    </div>
    <div class="input-bar-item">
    <button type="button"  onClick={fetchApi} className="btn btn-primary">Run Report</button>
   
    </div>
    <div class='input-bar-item'>
    <button type="button"  onClick={ResetFilter} className="btn btn-primary">Reset</button>
    </div>

    {/* <div className='downloadReportBtn'>
        {
          
          reportData.length>0 ? <button type="button"  onClick={fetchApiDownload} className="btn btn-primary">Download Report in Excel</button>:''
         
        }
       
      </div> */}

      <div className='downloadReportBtn'>
        {
          
           <button type="button"  onClick={fetchApiDownload} className="btn btn-primary">Download Report in Excel</button>
         
        }
       
      </div>
  </div>

  <div className="FilterSection">
  
  {filterArray.map((item, index) => (
      <span className="FilterSection"> 
       <span className='filterCategory' id={index}><span className="filterSpan">{item.field} = {item.value }</span>
       <span  onClick={(event) => deleteAdvancedFilterFn(item,index)}><CloseIcon className='closeIcon'/></span>
       </span>
       <span className="whitespaceSpan">{ '            ' }</span>
       </span>
      
    ))}    
  </div>

  {loader ?
  <div className='loaderDiv'>  
  <Loader type="ThreeDots" color="#2BAD60" height="100" width="100" /></div> : 
  
          <MaterialTable
          // onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}

          onRowClick={((evt, selectedRow) => 
            setRowBackground(selectedRow)
            )}
            columns={[

              { title: "Month", field: "month",
              cellStyle:(e,rowdata)=>{
                if(rowdata.last==1){
                  return {fontWeight:'bold'}
                }
              }
            },
              { title: "Total.Charge", field: "total_charge", 

              cellStyle:(e,rowdata)=>{
                if(rowdata.last==1){
                  return {fontWeight:'bold'}
                }
              }
          },
             
             
             
            ]}
            data={
                reportData
            }
            
             title={ReportTile}
            
            options={{
                actionsColumnIndex: -1,
                addRowPosition: "first",
                pageSize:10,
                loadingType: 'linear',
                paging: false,
                exportButton: true,
                maxBodyHeight: '500px',
                headerStyle: { position: 'sticky', top: 0,fontSize:'17px',fontWeight:'bold' },
                rowStyle: rowData => ({
                  backgroundColor: (selectedRow === rowData.tableData.id) ? clickColor : ''
                })
                
             
                
              }}
              
          />
        }
        </section>
       
      </div>

    )
}

function inArrayForString(needle, haystack) {
  var length = haystack.length;
  for (var i = 0; i < length; i++) {
  if (haystack[i].toLowerCase() == needle.toLowerCase())
   return true;
  }
  return false;
 }

function roundToTwo(num) {    
  return +(Math.round(num + "e+2")  + "e-2");
}

export default Shipcostbypickupdate
